import { memo } from "react";
import { usePlayerAvatar } from "@/hooks/usePlayerAvatar";

interface PlayerAvatarProps {
  uuid: string;
  size?: number;
  className?: string;
}

const PlayerAvatar = memo(({ uuid, size = 16, className = "" }: PlayerAvatarProps) => {
  const { data: avatarUrl, isLoading } = usePlayerAvatar(uuid, size);
  
  if (isLoading || !avatarUrl) {
    return (
      <div 
        className={`bg-muted rounded-sm animate-pulse ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }
  
  return (
    <img 
      src={avatarUrl}
      alt="Player avatar"
      className={`rounded-sm ${className}`}
      style={{ 
        width: size, 
        height: size, 
        imageRendering: 'pixelated' 
      }}
      loading="lazy"
      onError={(e) => {
        // Fallback to direct URL if data URL fails
        (e.target as HTMLImageElement).src = `https://mc-api.io/render/${uuid}?size=${size}`;
      }}
    />
  );
});

PlayerAvatar.displayName = 'PlayerAvatar';

export default PlayerAvatar;
